// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAyzov5uxPVXe7q5g2ueAikhRl9QKLTSSQ",
  authDomain: "irfanqureshi-portfolio.firebaseapp.com",
  projectId: "irfanqureshi-portfolio",
  storageBucket: "irfanqureshi-portfolio.appspot.com",
  messagingSenderId: "1087007502986",
  appId: "1:1087007502986:web:ad8fdad5ce4df1127eb373",
  measurementId: "G-P7GRGNWSBW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const storage = getStorage(app);